<template>
    <section class="kustomer-form is-open">
        <div v-if="!displaySuccessMessage">
            <h2 v-text="label()"></h2>

            <form @submit.prevent="submit">
                <input
                    type="email"
                    :style="{'border-bottom-color': '#FBCC1C'}"
                    placeholder="Enter Your Valid Email Address"
                    v-model="email_address"
                    required />
                <input
                    type="text"
                    readonly
                    :style="{'border-bottom-color': '#FBCC1C'}"
                    v-model="current_url_name" />
                <input
                    type="hidden"
                    name="current_url"
                    id="current_url"
                    v-model="current_url" />
                <textarea
                    :style="{'border-bottom-color': '#FBCC1C'}"
                    name="message"
                    id="message"
                    placeholder="Type Your Correction Details Here ..."
                    v-model="message"
                    rows="4"
                    required
                ></textarea>
                <button
                    type="submit"
                    :style="{'background-color': '#FBCC1C'}"
                    :class="{'is-loading': isLoading}"
                    :disabled="isLoading"
                >Submit Correction</button>
            </form>
        </div>
        <kustomer-success v-if="displaySuccessMessage" message="Corrections Submitted Successfully."></kustomer-success>
    </section>
</template>

<script>
//import html2canvas from 'html2canvas'

export default {
    props: [ 'params', 'labels'],

    data() {
        return {
            message: null,
            current_url_name: document.title,
            current_url: window.location.href,
            email_address: null,
            isLoading: false,
            displaySuccessMessage: false,
            screenshot: undefined
        }
    },
    methods: {
        label(type) {
            return 'Submit The Correction On the Page';
        },
        submit() {
            this.isLoading = true
                this.sendFeedback()
        },
        back() {
            this.displaySuccessMessage = false
            this.message = null
            this.$emit('unselected')
        },
        sendFeedback() {
            axios
                .post('/submit_correction', {
                    message: this.message,
                    current_url_name: this.current_url_name,
                    current_url: this.current_url,
                    email_address: this.email_address,
                })
                .then(response => {
                    this.isLoading = false
                    this.displaySuccessMessage = true
                })
                .catch(error => {
                    this.isLoading = false
                })
        }
    },

    components: {
        'kustomer-success': require('./SuccessMessage.vue').default
    }
}
</script>
